import { type FunctionComponent } from "react";
import { Navbar } from "@App/Components/Navbar";
import { Footer } from "@App/Layouts/Footer";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import type { State } from "@App/state";
import { Role } from "@App/types/ayvens/role";
import { useVehicleSelector } from "./BusinessLogic/backToVehicleSelector";
import { BackToVehicleSelectorButtonGroup } from "@App/Components/ClientSpecific/Ayvens/BackToVehicleSelector";

export const Layout: FunctionComponent = () => {
  const { resetTokenAndDriverData } = useVehicleSelector();

  const driverData = useSelector((state: State) => state.auth.driverData);
  const initialRole = useSelector((state: State) => state.auth.initialRole);

  return (
    <div className="font-sans text-neutral-900">
      <Navbar>
        <div className={"flex items-center gap-5"}>
          <img src="/images/brand/myald.png" className={"w-24"} alt="MyALD" />
          {[Role.AGENT, Role.FLEET_MANAGER].includes(initialRole as Role) && driverData && (
            <div className={"hidden md:flex gap-3"}>
              <BackToVehicleSelectorButtonGroup
                numberPlate={driverData.vehicle.numberPlate}
                onClick={() => resetTokenAndDriverData(initialRole as Role)}
              />
            </div>
          )}
        </div>
        <a href={"https://www.repareo.de"} className={"flex"} title={"repareo Werkstattvergleich"}>
          <img
            src="/images/brand/logoBlack.svg"
            className="w-28 h-auto"
            alt="repareo - Werkstattvergleich"
          />
        </a>
      </Navbar>
      {[Role.AGENT, Role.FLEET_MANAGER].includes(initialRole as Role) && driverData && (
        <div className="md:hidden bg-neutral-200 p-4 grid grid-flow-col justify-items-center">
          <BackToVehicleSelectorButtonGroup
            numberPlate={driverData.vehicle.numberPlate}
            onClick={() => resetTokenAndDriverData(initialRole as Role)}
          />
        </div>
      )}
      <Outlet />
      <Footer />
    </div>
  );
};
